<template>
  <VTask
    :task="task"
    v-bind="$attrs"
    :enabled="task.status === 'Open'"
    :show-from-name="false"
    icon-class="!-mt-0.5"
    @click="onClick"
  >
    <template #open>
      <VButton
        class="btn secondary !text-magenta-0 btn-sm !border-magenta-1 hover:!bg-task-btn-bg round"
        :class="btnSize"
        @click="onClick"
      >
        {{ task?.type === 'ASSESSMENT_ACKNOWLEDGEMENT' ? $t('acknowledge') : $t('share_results') }}
      </VButton>
    </template>
  </VTask>
</template>

<script>
import { useRouter } from 'vue-router';
// Components
import VTask from '@/components/templates/tasks/VTask';
import VButton from '@/components/VButton';

export default {
  components: {
    VTask,
    VButton
  },
  props: {
    task: {
      type: Object,
      default: () => ({})
    },
    btnSize: {
      type: String,
      default: ''
    }
  },
  emits: ['click'],
  setup (props, context) {
    // Misc
    const router = useRouter();

    // Methods
    const onClick = () => {
      const { review_id: reviewId, assessment_id: assessmentId } = props?.task?.details ? JSON.parse(props?.task?.details) : {};

      if (reviewId && assessmentId) {
        router.push({
          name: 'content-reviews-id-assessments-id-results',
          params: {
            id: reviewId,
            assessmentId
          }
        });

        context.emit('click');
      }
    };

    return {
      onClick
    };
  }
};
</script>
